import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Grid, Link } from '@mui/material';
import {
  competitorNames,
  CALCULATOR_MODE,
  toLocalePrice,
} from '@siren-frontend/shared';

import CompetitorSwitcher from './CompetitorSwitcher';
import ContactUsBox from './ContactUsBox';
import TalkToSalesLink from './TalkToSalesLink';
import { prices as astraPrices } from './models/astra.ts';
import { prices as dynamoPrices } from './models/dynamo.ts';

const pricingMapping = {
  [CALCULATOR_MODE.ASTRA]: astraPrices,
  [CALCULATOR_MODE.DYNAMO]: dynamoPrices,
};

function ComparePanel({ calculatorResult, calculatorInputs, mode, setMode }) {
  const scyllaPrice = calculatorResult?.prices?.[0]?.total;
  const computePriceFn = pricingMapping[mode];

  const workload = Object.fromEntries(
    Object.entries(calculatorInputs).map(([specId, specValues]) => [
      specId,
      specValues.value || specValues.default,
    ])
  );
  const ondemandCompetitorPrice = computePriceFn(workload)[0];
  const savings = ondemandCompetitorPrice.total - scyllaPrice;
  return (
    <Box className="compare-panel">
      <Box>
        <Button
          className="button"
          startIcon={<ArrowBackIcon />}
          onClick={() => setMode(CALCULATOR_MODE.DETAILS)}
        >
          Back
        </Button>
      </Box>
      <Box>
        <Box className="flex-container justified-center">
          <h1>ScyllaDB Cloud vs {competitorNames[mode]}&trade;</h1>
        </Box>
        <Box>
          <Grid container columns={8} className="vs-competitor-grid">
            <Grid item xs={3}>
              <Grid container direction="column" className="">
                <Grid item className="flex-container justified-center db-name">
                  <h1>ScyllaDB Cloud</h1>
                </Grid>
                <Grid item className="price-item">
                  <Box>On Demand</Box>
                  {savings <= 0 ? (
                    <TalkToSalesLink />
                  ) : (
                    <Box>
                      <span className="price-text">
                        ${toLocalePrice(scyllaPrice)}
                      </span>
                      /mo
                    </Box>
                  )}
                </Grid>
                <Grid item className="you-save-box roboto-font">
                  {savings <= 0 ? (
                    <>
                      <Link
                        href="https://www.scylladb.com/pricing#request-pricing"
                        className=""
                        target="_blank"
                      >
                        Speak with a rep &gt;
                      </Link>
                      <br />
                      <span className="font-bolder">
                        <br />
                      </span>
                    </>
                  ) : (
                    <>
                      You Save
                      <br />
                      <span className="font-bolder">
                        $
                        {toLocalePrice(
                          ondemandCompetitorPrice.total - scyllaPrice
                        )}
                      </span>
                      /mo
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <Grid container direction="column">
                <Grid item className="flex-container justified-center db-name">
                  <h1>{competitorNames[mode]}</h1>
                </Grid>
                <Grid className="price-item" item>
                  <Box>{ondemandCompetitorPrice.name}</Box>
                  {savings <= 0 ? (
                    <TalkToSalesLink />
                  ) : (
                    <Box>
                      <span className="price-text">
                        ${toLocalePrice(ondemandCompetitorPrice.total)}
                      </span>
                      /mo
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2}>
              <ContactUsBox />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box
        item
        xs={2}
        className="flex-container direction-column justified-center aligned-center"
      >
        <Box>
          <h3>Compare Pricing</h3>
        </Box>
        <CompetitorSwitcher setMode={setMode} />
      </Box>
    </Box>
  );
}

export default ComparePanel;
